import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const LoyaltyPageContainer = styled('div')`
  width: 80%;
  margin: 0 auto;
  padding: 16px 0 0;
  min-height: calc(100vh - 200px);
  position: relative;
  border: 1px solid ${baseTheme.colors.mainLightBlue};
  background-color: lightblue;
  display: flex;
  flex-direction: column;

  h2 {
    margin: 0 0 15px;
    font-size: 16px;
    font-weight: 600;
    padding-left: 16px;
  }
`;

export const NetworkBlock = styled('div')`
  display: flex;
  position: relative;

  .selected-network {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    word-break: break-word;
    align-items: center;
    padding: 10px 12px;
    width: 240px;
    font-weight: 400;
    font-size: 16px;
    color: ${baseTheme.colors.secondary};
    border: 1px solid ${baseTheme.colors.stroking};
    border-radius: 8px;
  }
`;

export const PickersBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: white;
  padding: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PickersTop = styled('div')`
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PickersContainer = styled('div')`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Picker = styled('div')`
  display: flex;
  flex-direction: column;
  margin-right: 55px;

  .label {
    color: ${baseTheme.colors.secondary};
    font-weight: 500;
    padding-bottom: 4px;
  }

  .day {
    min-height: 30px;
    padding: 4px;
    border: 1px solid ${baseTheme.colors.secondary};
    border-radius: 8px;
    margin: 8px 0;
  }
  @media (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const GenerateButton = styled('div')`
  margin-top: 73px;
  position: relative;

  label {
    color: ${baseTheme.colors.secondary} !important;
    margin-bottom: 16px;
    font-weight: 500 !important;
  }

  .error-tooltip {
    width: 350px;
    background-color: #f6f9ff;
    filter: drop-shadow(0px 1px 8px rgba(0, 58, 136, 0.15));
    border-radius: 4px;
    color: ${baseTheme.colors.primary};
    font-size: 16px;
    font-weight: 400;
    padding: 8px 16px;
    position: absolute;
    top: -65px;
    @media (max-width: 768px) {
      width: 50vw;
      white-space: normal;
      word-wrap: break-word;
      height: auto;
      top: -95px;
    }
  }
`;

export const TogglesBlock = styled('div')`
  margin-top: 16px;

  div:first-child {
    margin-bottom: 8px;
  }
`;

export const CurrentParametersBlock = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 16px;

  .header-cell {
    font-weight: bold;
  }
`;

export const ExpandedProductBonusBlock = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  padding: 16px;
`;

// Блок для формы начисления дополнительных бонусов.
export const AdditionalBonusContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: white;
  padding: 16px;
`;

export const AdditionalBonusForm = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
`;

export const AdditionalBonusField = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 260px;

  .label {
    color: ${baseTheme.colors.secondary};
    font-weight: 500;
    padding-bottom: 4px;
  }
`;

export const AdditionalBonusFieldReason = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 260px;

  .label {
    color: ${baseTheme.colors.secondary};
    font-weight: 500;
    padding-bottom: 4px;
  }
`;

export const AdditionalBonusActions = styled('div')`
  display: flex;
  justify-content: flex-end;
`;

export const PharmaciesBlock = styled('div')`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 400px;
`;

export const ButtonsBlock = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const DeleteProductButton = styled('div')`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  padding: 16px;
  border: 1px solid ${baseTheme.colors.mainLightBlue};
  border-radius: 50%;
  color: ${baseTheme.colors.mainLightBlue};
  font-size: 16px;
  font-weight: 700;

  &:hover {
    border-color: ${baseTheme.colors.error};
    color: ${baseTheme.colors.white};
    background-color: ${baseTheme.colors.error};
  }
`;

export const ConfirmationDeleteModal = styled('div')`
  width: 500px;
  height: 250px;
  background-color: ${baseTheme.colors.white};
  border-radius: 8px;
  border: none;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 20px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
  }

  .buttons-block {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    gap: 30px;
  }

  .button-cancel {
    font-size: 16px;
    background-color: ${baseTheme.colors.mainBlue};
    border: 1px solid ${baseTheme.colors.mainBlue};
    color: ${baseTheme.colors.white};
    border-radius: 8px;
    padding: 10px 20px;
  }

  .button-delete {
    font-size: 16px;
    background-color: ${baseTheme.colors.white};
    border: 1px solid ${baseTheme.colors.mainLightBlue};
    border-radius: 8px;
    padding: 10px 20px;
  }
`;
